import { render, staticRenderFns } from "./ModalSettings.vue?vue&type=template&id=cd3c0ad6&"
import script from "./ModalSettings.vue?vue&type=script&lang=js&"
export * from "./ModalSettings.vue?vue&type=script&lang=js&"
import style0 from "./ModalSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports